export function informedConsentSellerLandlordCBDP() {
return [   // Release 2026-08-12 09:34:38
//  {
//    page: 0,
//  name: "Logo",
//  type: "logo",
//  top: 28.673,
//  left: 53,
//  width: 240,
//  height: 36,
//  }, 
{
   page: 0,
   name: "Seller Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 132.436,
   left: 304.2,
   width: 267.862,
   height: 11.619
}
,
{
   page: 1,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 193.44,
   left: 210.72,
   width: 362.04,
   height: 13.44
}
,
{
   page: 1,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 232.32,
   left: 41.88,
   width: 531.00,
   height: 13.32
}
] }
